import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class PceOsSupportModel extends IllumioEventEmitter {
    constructor() {
        super();

        // this.dataLoadEvent = new Event(this);
        let url = '/api/v1/pce_software/os_support/pce.json'
        if (IllumioSupportUtils.isPublicResource()) {
            url = '/api/v1/shared/pce_software/os_support/pce.json'
        }
        $.ajax({
            dataType: 'json',
            method: 'get',
            contentType: 'application/json; charset=utf-8',
            url: url,
            error: this.ajaxErrorHandler.bind(this),
            success: this.ajaxSuccessHandler.bind(this),
        });
    }

    ajaxSuccessHandler(response, textStatus, jqXHR) {
        console.debug('ajaxSuccessHandler() invoked.');
        if (response && response.data) {
            this.success = true;
            this.data = response.data;
            // this.dataLoadEvent.notify();
            this.emit('dataLoad', {});
        } else {
            this.success = false;
            this.error = response.error;
        }
    }

    ajaxErrorHandler() {
        console.warn('ajaxErrorHandler() invoked.');
        const result = new PceOsSupportResult();
        result.renderError(null);
    }

        /**
         * Public method
         */
        getRecordByVersion(pceVersion) {
            if (this.data['os_content']) {
                for (let id in this.data['os_content']) {
                    if (this.data['os_content'][id].software_version===pceVersion) {
                        return this.data['os_content'][id];
                    }
                }
            }
            return null;
        }
}

export class PceOsSupportView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        this.formDiv = document.getElementById('formDiv');
        this.pceVersionSelect = document.getElementById('pceVersionSelect');

        this.pceVersionSelect.onchange = this.pceVersionSelectOnChangeHandler.bind(this);

        // this.model.dataLoadEvent.attach(dataLoadEventHandler.bind(this));
        this.model.on('dataLoad', this.dataLoadEventHandler.bind(this));

        this.result = new PceOsSupportResult();
    }

        /**
         * Public method
         */
        showResult(id) {
            if (!id && this.pceVersionSelect && this.pceVersionSelect.options.selectedIndex>=0) {
                id = this.pceVersionSelect.options[this.pceVersionSelect.options.selectedIndex].value
            }
            console.debug(`selected id: ${id}`);
            this.result.render(this.model.data['os_content'][id], this.model.data['compatibility'][this.model.data['os_content'][id]['software_version']]);

            location.hash = this.model.data['os_content'][id].software_version;

            this.trackAnalytic();
        }

    pceVersionSelectOnChangeHandler(event) {
        console.debug('pceVersionSelectOnChangeHandler() invoked');
        this.showResult(event.target.value);
    }

    dataLoadEventHandler(event) {
        console.debug('dataLoadEventHandler() invoked!');
        if (this.model.success && this.model.data['os_content']) {
            let itemCounter = 0;
            const optionsArray = new Array();
            for (let id in this.model.data['os_content']) {
                const item = this.model.data['os_content'][id];

                let text = item.software_version;
                if (item.lts) {
                    text += ' (LTS)';
                }

                optionsArray.push(new Option(text, item.id));
            }
            if (optionsArray.length>0) {
                const optionsArraySortHandler = function(a, b) {
                    if (a.text>b.text) {
                        return -1;
                    } else if (a.text<b.text) {
                        return 1;
                    }
                    return 0;
                }
                optionsArray.sort(optionsArraySortHandler);

                const optionsArrayForEachHandler = function(optionItem) {
                    console.debug(optionItem);
                    console.debug(this);
                    this.pceVersionSelect.options.add(optionItem);
                }
                optionsArray.forEach(optionsArrayForEachHandler.bind(this), this);
            }
            if (this.pceVersionSelect.options.length>0) {
                this.defaultPceVersionSelect();
                this.formDiv.classList.remove('hidden');
                $(this.pceVersionSelect).change();
            } else {
                this.result.renderError(null);
            }
        }
    }

    defaultPceVersionSelect() {
        let found = false;
        if (location.hash && location.hash.length>1) {
            const record = this.model.getRecordByVersion(location.hash.substring(1));

            if (record) {
                for (let i=0;i<this.pceVersionSelect.options.length;i++) {
                    let option;
                    if (this.pceVersionSelect.options[i].text.includes('(')) {
                        option = this.pceVersionSelect.options[i].text.substring( 0, this.pceVersionSelect.options[i].text.indexOf('(')).trim();
                    } else {
                        option = this.pceVersionSelect.options[i].text;
                    }
                    if (record.software_version.trim() === option) {
                        found = true;
                        this.pceVersionSelect.options[i].selected = true;
                        break;
                    }
                }
            }
        }

        if (!found) {
            this.pceVersionSelect.options.selectedIndex = 0;
        }
    }

    trackAnalytic() {
        if (IllumioSupportUtils && this.pceVersionSelect.selectedIndex>=0) {
            const eventLabel = this.pceVersionSelect.options[this.pceVersionSelect.selectedIndex].text;
            console.debug(`eventLabel: ${eventLabel}`);
            IllumioSupportUtils.trackGaEvent('OS Support', 'PCE', eventLabel);
        }

        const qs = IllumioSupportUtils.getJsonFromUrl(location.href);
        if (qs && qs['source']) {
            IllumioSupportUtils.trackGaEvent('OS Support', 'PCE Redirect', qs['source'])
            console.debug('Tracked PCE redirect');
        }
    }
}

export class PceOsSupportController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
    }
}

export class PceOsSupportResult {
    constructor() {
        this.pceContent = document.getElementById('pceContent');
    }

        /**
         * Public method
         */
        render(record, compatibilities) {
            this.pceContent.innerHTML = this.createCompatibilityTables(record, compatibilities);
            this.pceContent.innerHTML += record.view;
            this.updateSupportedOperatingSystemsFormat();
            this.updateHeading(record);
            this.updateBrowserIcons();
        }

        /**
         * Public method
         */
        renderError(message) {
            if (!message) {
                message = `We're sorry that we have experienced technical difficulties in retrieving the content. Please try again later.`;
            }
            this.pceContent.innerHTML = message;
        }

    createCompatibilityTables(record, compatibilities) {
        if (!compatibilities) {
            console.debug('createCompatibilityTables(): compatibilities is null');
            return '';
        }
        const software_type_titles = {
            'ven': 'VEN',
            'cli': 'CLI',
            'flowlink': 'Flowlink',
            'nen': 'NEN'
        }

        const software_types = ['ven','cli','flowlink','nen'];
        let i = 0;
        while (i < software_types.length) {
            if (!compatibilities[software_types[i]])  {
                software_types.splice(i,1);
            } else {
                i += 1;
            }
        }
        // Add any missing software types
        for (let software_type in compatibilities) {
            if (!software_type_titles[software_type]) {
                software_type_titles[software_type] = software_type.toUpperCase();
            }
        }

        // Generate headers
        let compatability_html = "<h2>COMPATIBILITY</h2><table class='ilo-tabular'><tbody><tr>";
        const headers = ['Software type', 'Version'];
        for (let i in headers) {
            compatability_html += `<th>${headers[i]}</th>`;
        }
        compatability_html += '</tr>';

        for (let i in software_types) {
            compatability_html += '<tr>';
            if (compatibilities[software_types[i]]) {
                compatability_html += `<td>${software_type_titles[software_types[i]]}</td><td><ul>`;
                const sorted_keys = Object.keys(compatibilities[software_types[i]]).sort().reverse();
                for (let j = 0; j < sorted_keys.length; j++) {
                    compatability_html += `<li>${sorted_keys[j]}</li>`;
                }
               
               
                compatability_html += "</ul></td>";
            }
            compatability_html += '</tr>';
        }
        compatability_html += "</tbody></table>";

        return compatability_html
    }

    updateSupportedOperatingSystemsFormat() {
        let table = document.getElementsByClassName("relative-table wrapped confluenceTable")[0];
        
        if (!table){
         table = document.getElementsByClassName("wrapped ilo-tabular relative-table confluenceTable")[0];
        }
        if (!table){
            table = document.getElementsByClassName("relative-table confluenceTable")[0];
        }
        if (table == null){//SP-832 check if null before moving on.
            console.log('returning from the 1st if')
            return;
        }
        let tbody = table.getElementsByTagName('tbody');
        if (tbody && tbody.length>0) {
            tbody = tbody[0]
        } else {
            return;
        }
        const header = table.children[0];

        // Check if the header has 3 items for backwards compatability
        if (!header.children[2]) {
            console.log('header',header);
            //console.log('returning')
            //return
        }
        console.log('header',header);
        let newHTML = "";
        table.style.width = "";

        // There is an unneccasary colgroup in the HTML here
        table.removeChild(table.children[1]);

        // Delete the "qualified" header then grab the rest of it
        //header.removeChild(header.lastElementChild);

        const realheader = header.lastElementChild;
        realheader.removeChild(realheader.lastElementChild);

        // Start at 1 becuase 0 is the header
        let index = 0;
        while (tbody.children[index]) {
            do {
                const tr = tbody.children[index];
                if (tr.children.length == 3) {
                    // Add the OS
                    newHTML += `<tr><td>${tr.children[0].innerText}</td><td><ul>`;
                }
                // Add the version
                
                newHTML += `<li class='support-status status-qualified'>${tr.children[tr.children.length-2].innerText}</li>`;
                index += 1;
            } while (tbody.children[index] && tbody.children[index].children.length != 3);
            newHTML += "</ul></td></tr>";
        }
        tbody.innerHTML = newHTML;
    }

    updateHeading(record) {
        const headings = document.getElementsByTagName('h2');
        for (let i=0;i<headings.length;i++) {
            headings[i].textContent += ` for Illumio PCE ${record.software_version}${(record.lts) ? ' LTS': ''}`;
            console.debug(headings[i].textContent);
        }
    }

    updateBrowserIcons() {
        let browserHeading = null;
        const confluenceThs = document.getElementsByClassName('confluenceTh');
        for (let i=0;i< confluenceThs.length;i++) {
            if (confluenceThs[i].textContent.match(/Browser/)) {
                browserHeading = confluenceThs[i];
                break;
            }
        }
        if (browserHeading ) {
            let row = browserHeading.parentElement;
            while (row.nextElementSibling) {
                row = row.nextElementSibling;
                if (row.childElementCount>0) {
                    const browserCell = row.children[0];
                    if (browserCell.childNodes.length>0) {
                        var browserName = browserCell.textContent;
                        var textNode = browserCell.childNodes[0];
                        browserCell.removeChild(textNode);

                        var element = document.createElement('i');
                        element.style.marginRight = '0.5rem';
                        element.classList.add('fa-brands');
                        element.classList.add(getAwesomeFontName(browserName));

                        browserCell.appendChild(element);
                        browserCell.appendChild(textNode);
                    }
                }
            }
        }
    }

    getAwesomeFontName(browserName) {
        let className = null;

        if (browserName) {
            switch(browserName.trim()) {
                case 'Chrome':
                    className = 'fa-chrome';
                    break;
                case 'FireFox':
                    className = 'fa-firefox';
                    break;
                case 'Internet Explorer':
                    className = 'fa-internet-explorer';
                    break;
                case 'Microsoft Edge':
                    className = 'fa-edge';
                    break;
            }
        }

        return className;
    }
}
